import BigNumber from 'bignumber.js'
import React, {useCallback, useEffect, useMemo, useState} from 'react'
import Button from '../../../components/Button'
import Modal, {ModalProps} from '../../../components/Modal'
import ModalActions from '../../../components/ModalActions'
import ModalTitle from '../../../components/ModalTitle'
import TokenInput from '../../../components/TokenInput'
import {getBalanceNumber, getFullDisplayBalance} from '../../../utils/formatBalance'
import useFarms from "../../../hooks/useFarms";
import styled from "styled-components";

interface DepositModalProps extends ModalProps {
    getTokenAmout: BigNumber,
    staked: BigNumber,
    onConfirm: (amount: string,tokenAmout:BigNumber) => void
    tokenName?: string
}

export const DepositModal: React.FC<DepositModalProps> = ({
                                                              getTokenAmout,
                                                              staked,
                                                              onConfirm,
                                                              onDismiss,
                                                              tokenName = '',
                                                          }) => {
    const [val, setVal] = useState('');
    const [farms] = useFarms();

    const [pendingTx, setPendingTx] = useState(false);





    const fullBalance = useMemo(() => {
        let allStaked: BigNumber = new BigNumber(2);
        farms.forEach((ev) => {
            allStaked = allStaked.plus(ev.tokenBalance);
            console.log(getBalanceNumber(ev.tokenBalance));
        });
        let realBalance: BigNumber = getTokenAmout.plus(allStaked);
         let available = realBalance.minus(staked.times(4));
        // let available = realBalance;
        console.log('-----staked------>',getBalanceNumber(allStaked), '\n',
            '-----realBalance------>',getBalanceNumber(realBalance), '\n',
            '-----available------>',getBalanceNumber(available));

        if (available.comparedTo(1e18) < 0) {
            available = new BigNumber(0);
        }
        if(available.comparedTo(getTokenAmout.times(4)) > 0 ){
            available = getTokenAmout.times(4);
        }
        return getFullDisplayBalance(available)
    }, [getTokenAmout]);

    const handleChange = useCallback(
        (e: React.FormEvent<HTMLInputElement>) => {
            setVal(e.currentTarget.value)
        },
        [setVal],
    );


    const handleSelectMax = useCallback(() => {
        setVal(fullBalance)
    }, [fullBalance, setVal]);


    return (
        <Modal>
            <StylePadding>
                <ModalTitle text={ `Adding to ${tokenName} Pool`}/>
                <TokenInput
                    value={val}
                    onSelectMax={handleSelectMax}
                    onChange={handleChange}
                    max={fullBalance}
                    symbol="Staking Power"
                />
                <ModalActions>
                    <Button text="Cancel" variant="secondary" color="#2765A6" bGColor="#17254A" size="sm" onClick={onDismiss}/>
                    <Button
                        disabled={parseFloat(val) > parseFloat(fullBalance)}
                        size="sm"
                        text="Confirm"
                        onClick={async () => {
                            if (!val) return;
                            onDismiss();
                            await onConfirm(val,getTokenAmout);
                            // setPendingTx(false);
                            // onDismiss()
                        }}
                    />
                </ModalActions>
            </StylePadding>

        </Modal>
    )
};


export const StylePadding = styled.div`
padding: 20px 30px;
box-sizing: border-box;
//width: 500px;
`;

